export function normalizeFloorPlan(plan) {
  return {
    ...plan,
    nodes: (plan.nodes || []).map((node) => ({
      ...node,
      trackingEdge: node.trackingEdge === true,
      houseBoundary: node.trackingEdge === true && node.houseBoundary === true,
    })),
  };
}

export function updateMapNode(plan, nodeId, updates) {
  return normalizeFloorPlan({
    ...plan,
    nodes: (plan.nodes || []).map((node) =>
      node.id === nodeId ? { ...node, ...updates, id: node.id } : node
    ),
  });
}